import React from "react";

export default function Terms() {
    return (
        <div className="pt-32 pb-24" data-testid="terms-page">
            <div className="max-w-3xl mx-auto px-6 md:px-12">
                <p className="text-pep-primary text-sm uppercase tracking-widest font-medium mb-3">Legal</p>
                <h1 className="font-heading text-5xl sm:text-6xl tracking-tighter text-pep-navy font-medium mb-6">
                    Terms of Service
                </h1>
                <p className="text-pep-muted text-sm mb-12">Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })}</p>

                <div className="prose prose-pepstep max-w-none space-y-8 text-pep-navy leading-relaxed">
                    <Section title="1. Acceptance of Terms">
                        By accessing or using the PepStep website (the "Site") you agree to be bound by these Terms of Service. If you do not agree, do not use the Site.
                    </Section>
                    <Section title="2. Research Use Only">
                        All products sold by PepStep are intended <strong>strictly for in-vitro and laboratory research purposes</strong>. They are not for human or animal consumption, diagnostic, or therapeutic use. By purchasing you confirm you are acting in a research capacity and accept all responsibility for safe and lawful handling.
                    </Section>
                    <Section title="3. Eligibility">
                        You must have the legal capacity to enter into a binding contract under Australian law to place an order. Orders are accepted at our sole discretion.
                    </Section>
                    <Section title="4. Orders and Payment">
                        We currently accept payment via bank transfer. Your order is held as "pending" until payment is confirmed. We reserve the right to cancel or refuse any order. Prices are listed in AUD and may change without notice; the price displayed at checkout is the price you pay.
                    </Section>
                    <Section title="5. Shipping">
                        Standard shipping is $25 flat, with free shipping on orders over $250. We typically dispatch within 1-2 business days of payment confirmation. Same-day delivery is available in the Sydney metro area. Delivery times depend on courier and destination and are not guaranteed.
                    </Section>
                    <Section title="6. Returns and Refunds">
                        Due to the nature of research compounds, all sales are final once the order has shipped. If a shipment is lost in transit or arrives compromised, contact us within 7 days with evidence and we will reship at no charge or refund at our discretion.
                    </Section>
                    <Section title="7. Limitation of Liability">
                        PepStep is not liable for any direct, indirect, incidental, or consequential damages resulting from misuse of our products or from any errors or omissions on the Site. Our maximum liability is limited to the value of the products purchased.
                    </Section>
                    <Section title="8. Intellectual Property">
                        All content on the Site (text, graphics, logos, images) is the property of PepStep or its licensors and is protected by copyright and trade-mark law.
                    </Section>
                    <Section title="9. Governing Law">
                        These Terms are governed by the laws of the Commonwealth of Australia. Any disputes shall be resolved in the courts of New South Wales.
                    </Section>
                    <Section title="10. Contact">
                        Questions about these Terms? Email <a href="mailto:orders@pepstep.com" className="text-pep-primary hover:underline">orders@pepstep.com</a>.
                    </Section>
                </div>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <div>
            <h2 className="font-heading text-2xl font-medium text-pep-navy mb-3">{title}</h2>
            <p className="text-pep-muted">{children}</p>
        </div>
    );
}
